import React from 'react'
import { Button } from './button'

interface CloseButtonProps {
  onClose: () => void
  className?: string
}

/**
 * Collapse button component for chat widgets
 * Shows an "×" symbol with hover effects to collapse messages back to input-only state
 */
export function CloseButton({ onClose, className = '' }: CloseButtonProps) {
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onClose}
      className={`h-8 w-8 p-0 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full ${className}`}
      aria-label="Collapse chat"
      title="Collapse chat"
    >
      <span className="text-lg leading-none">×</span>
    </Button>
  )
}
